import { layoutRoute } from '@app/router/layout';
import { createRoute } from '@tanstack/react-router';
import DocumentsCenter from '@modules/banks/presentation/v2/pages/DocumentsCenter';
import BankUpdates from '@modules/banks/presentation/v2/pages/BankUpdates';
import BankProductsPage from '../pages/BankProducts';

export const BankUpdatesRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/bank-updates',
  beforeLoad: () => ({
    breadcrumb: { key: 'bankUpdates' },
    featureName: 'banks.updates',
  }),
  component: () => <BankUpdates />,
});

export const DocumentsCenterRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/documents-center',
  beforeLoad: () => ({
    breadcrumb: { key: 'documentsCenter' },
    featureName: 'banks.documents',
  }),
  component: () => <DocumentsCenter />,
});

export const BankProductsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/bank-products',
  beforeLoad: () => ({
    breadcrumb: { key: 'bankProducts' },
    featureName: 'banks.products',
  }),
  component: () => <BankProductsPage />,
});
